import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {PrehladStudia} from '../model/PrehladStudia';
import {Subscription} from 'rxjs';
import {Priemery} from '../model/Priemery';

@Component({
    selector: 'app-prehlady',
    templateUrl: './prehlady.component.html',
    styleUrls: ['./prehlady.component.css'],
    standalone: false
})
export class PrehladyComponent implements OnInit {

  public prehlady: PrehladStudia[];
  private prehladySubscription = new Subscription();

  public priemery: Priemery;
  private priemerySubscription = new Subscription();

  public pocetZapisane = 0;
  public pocetZapisaneA = 0;
  public pocetZapisaneB = 0;
  public pocetZapisaneC = 0;
  public pocetZapisaneIne = 0;

  public pocetAbsolvovane = 0;
  public pocetAbsolvovaneA = 0;
  public pocetAbsolvovaneB = 0;
  public pocetAbsolvovaneC = 0;
  public pocetAbsolvovaneIne = 0;

  public kredityZapisane = 0;
  public kredityZapisaneA = 0;
  public kredityZapisaneB = 0;
  public kredityZapisaneC = 0;
  public kredityZapisaneIne = 0;

  public kredityAbsolvovane = 0;
  public kredityAbsolvovaneA = 0;
  public kredityAbsolvovaneB = 0;
  public kredityAbsolvovaneC = 0;
  public kredityAbsolvovaneIne = 0;

  public uznane = 0;

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.prehladySubscription = this.appService.prehladySubject
      .subscribe(
      (data: PrehladStudia[]) => {
        this.parseData(data);
      }
    );

    this.priemerySubscription = this.appService.priemerySubject
      .subscribe(
        (data: Priemery) => {
          this.priemery = data;
        }
      );

    this.parseData(this.appService.getPrehlady());

    this.priemery = this.appService.getPriemery();
  }

  private parseData(data: PrehladStudia[]) {

    this.pocetZapisane = 0;
    this.pocetZapisaneA = 0;
    this.pocetZapisaneB = 0;
    this.pocetZapisaneC = 0;
    this.pocetZapisaneIne = 0;

    this.pocetAbsolvovane = 0;
    this.pocetAbsolvovaneA = 0;
    this.pocetAbsolvovaneB = 0;
    this.pocetAbsolvovaneC = 0;
    this.pocetAbsolvovaneIne = 0;

    this.kredityZapisane = 0;
    this.kredityZapisaneA = 0;
    this.kredityZapisaneB = 0;
    this.kredityZapisaneC = 0;
    this.kredityZapisaneIne = 0;

    this.kredityAbsolvovane = 0;
    this.kredityAbsolvovaneA = 0;
    this.kredityAbsolvovaneB = 0;
    this.kredityAbsolvovaneC = 0;
    this.kredityAbsolvovaneIne = 0;

    this.uznane = 0;

    data.forEach(p => {

      this.pocetZapisane += p.pocetZapisane;
      this.pocetAbsolvovane += p.pocetAbsolvovane;
      this.kredityZapisane += p.kredityZapisane;
      this.kredityAbsolvovane += p.kodTypVyucby === 'UZNANE' ? 0 : p.kredityAbsolvovane;

      if (p.kodTypVyucby === 'A') {
        this.pocetZapisaneA += p.pocetZapisane;
        this.pocetAbsolvovaneA += p.pocetAbsolvovane;
        this.kredityZapisaneA += p.kredityZapisane;
        this.kredityAbsolvovaneA += p.kredityAbsolvovane;
      }
      if (p.kodTypVyucby === 'B') {
        this.pocetZapisaneB += p.pocetZapisane;
        this.pocetAbsolvovaneB += p.pocetAbsolvovane;
        this.kredityZapisaneB += p.kredityZapisane;
        this.kredityAbsolvovaneB += p.kredityAbsolvovane;
      }
      if (p.kodTypVyucby === 'C') {
        this.pocetZapisaneC += p.pocetZapisane;
        this.pocetAbsolvovaneC += p.pocetAbsolvovane;
        this.kredityZapisaneC += p.kredityZapisane;
        this.kredityAbsolvovaneC += p.kredityAbsolvovane;
      }

      if (p.kodTypVyucby === 'UZNANE') {
        this.uznane += p.kredityAbsolvovane;
      }

    });
  }
}
